import React from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  IconButton,
  Typography
} from '@mui/material';
import { Add, KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { sectionSx, summarySx, sectionTitleSx, addIconSx } from './styles';

const MedicalSection = ({ title, expanded, onChange, onAdd, children }) => {
  return (
    <Accordion disableGutters expanded={expanded} onChange={onChange} sx={sectionSx}>
      <AccordionSummary
        expandIcon={expanded ? <KeyboardArrowUp fontSize="small" sx={{color:'#757575'}} /> : <KeyboardArrowDown fontSize="small" sx={{color:'#757575'}}/>}
        sx={summarySx}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          <Typography sx={sectionTitleSx}>{title}</Typography>

          <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center' }}>
            <IconButton
              size="small"
              sx={addIconSx}
              onClick={event => {
                event.stopPropagation();
                onAdd?.();
              }}
            >
              <Add fontSize="small" sx={{color:'#757575'}} />
            </IconButton>
          </Box>
        </Box>
      </AccordionSummary>

      <AccordionDetails sx={{ p: 0 }}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

MedicalSection.propTypes = {
  title: PropTypes.string,
  expanded: PropTypes.bool,
  onChange: PropTypes.func,
  onAdd: PropTypes.func,
  children: PropTypes.node
};

export default MedicalSection;